import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				background: theme.palette.common.white,
				padding: 10,
				marginTop: 16,
				borderRadius: 6
			},
			rootHeader: {
				fontSize: 14,
				fontWeight: 500,
				color: theme.palette.primary.contrastText,
				borderBottom: `1px dashed ${theme.palette.grey[800]}`,
				paddingBottom: 10,
				marginBottom: 10
			},
			text: {
				fontSize: 14,
				fontWeight: 400,
				marginBottom: 10,
				textAlign: "justify"
			},
			dot: {
				height: 4,
				width: 4,
				backgroundColor: theme.palette.common.back,
				borderRadius: "50%",
				display: "inline-block",
				marginRight: 5,
				marginBottom: 3
			}
		}),
	{
		name: "Loyalty",
		index: 1
	}
);

export default useStyles;
